var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "configuration-buildings-container" },
    [
      _c("buildings-list", {
        attrs: { buildings: _vm.allBuildings, isLoading: _vm.isLoading }
      }),
      _vm._v(" "),
      _c("v-card", { staticClass: "workspace-card-container" }, [
        _c("h3", { staticClass: "workspace-title" }, [_vm._v("Map")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "workspace-container" },
          [
            _c("workspace-map", {
              ref: "workspaceMap",
              attrs: {
                workspace: _vm.workspace,
                polygon: _vm.polygon,
                "draw-polygon": false,
                "view-all-workspaces": false,
                "is-npv": true,
                "is-npv-buildings": true,
                buildings: _vm.allBuildings
              }
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-63d76c8e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63d76c8e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Npv/Configuration/views/ConfigurationBuildings.vue
// module id = null
// module chunks = 